import React from 'react';
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Bucket } from '../../lib/calc';
import { fmtPct } from '../../lib/cn';
export function BucketBarChart({
  data
}: {
  data: Bucket[];
}) {
  if (data.length === 0) return <EmptyChart data-id="element-98" data-mp="3mw7uf4pu22i3" />;
  return <ResponsiveContainer width="100%" height={220} data-id="element-99" data-mp="3mwzdxh65o9s0">
      <BarChart data={data} margin={{
      top: 4,
      right: 8,
      left: -18,
      bottom: 0
    }} barCategoryGap={data.length > 8 ? 2 : 12} data-id="element-100" data-mp="3myamrvegk7pz">
        <XAxis dataKey="label" tick={{
        fontSize: 11,
        fill: '#6b7280'
      }} axisLine={false} tickLine={false} interval={0} angle={data.length > 6 ? -30 : 0} textAnchor={data.length > 6 ? 'end' : 'middle'} height={data.length > 6 ? 46 : 24} data-id="element-101" data-mp="3d5d7dy4riyvl" />
        <YAxis tick={{
        fontSize: 11,
        fill: '#6b7280'
      }} axisLine={false} tickLine={false} width={44} tickFormatter={v => `${v}%`} data-id="element-102" data-mp="2z5u017jrzrkc" />
        <Tooltip cursor={{
        fill: 'rgba(0,0,0,0.03)'
      }} contentStyle={tooltipStyle} formatter={(v: number) => [fmtPct(v), 'Resultado']} data-id="element-103" data-mp="28xm1h1onqhuv" />
        <Bar dataKey="resultPct" radius={[6, 6, 0, 0]} maxBarSize={48} data-id="element-104" data-mp="1zzidzzu43b0f">
          {data.map(d => <Cell key={d.key} fill={d.resultPct >= 0 ? '#16a34a' : '#dc2626'} data-id="element-105" data-mp="2413xi415injl" />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>;
}
export const tooltipStyle: React.CSSProperties = {
  borderRadius: 12,
  border: '1px solid #eceef2',
  boxShadow: '0 8px 24px rgba(16,24,40,0.10)',
  fontSize: 12,
  padding: '8px 10px'
};
export function EmptyChart() {
  return <div className="flex h-[220px] items-center justify-center rounded-xl border border-dashed border-line bg-surface/40 text-[13px] text-ink-soft" data-id="element-106" data-mp="2nm8e2vmwgvie">
      Sin datos todavía
    </div>;
}